/* eslint-disable */
// @ts-nocheck
import OtaClient, { ClientConfig } from "@crowdin/ota-client"

interface ICrowdinSingleLanguageResponse {
  file: string
  content: Record<string, string>
}
type CrowdinGetLanguageTranslationResponse = ICrowdinSingleLanguageResponse[]

interface ICrowdinBackendOptions extends ClientConfig {
  distributionHash: string
}

class Backend {
  type: "backend"
  prevTimestamp: string
  timestamp: string
  client: OtaClient
  loadedLanguages: Set<string>

  constructor() {
    this.type = "backend"
    this.prevTimestamp = localStorage.getItem(
      process.env.CROWDIN_LOCAL_STORAGE_MANIFEST_TIMESTAMP
    )
    this.loadedLanguages = new Set()
  }

  shouldRefreshTranslations(currentTimestamp: string) {
    return this.prevTimestamp !== currentTimestamp
  }

  init(
    _services: any,
    { distributionHash, ...options }: ICrowdinBackendOptions
  ) {
    this.client = new OtaClient(distributionHash, options)
    this.client.getManifestTimestamp().then((timestamp) => {
      this.timestamp = timestamp.toString()
      if (this.shouldRefreshTranslations(timestamp.toString())) {
        localStorage.setItem(
          process.env.CROWDIN_LOCAL_STORAGE_MANIFEST_TIMESTAMP,
          timestamp.toString()
        )
      }
    })
  }

  read(
    language: string,
    _namespace: string,
    callback: (error: any, translations: any) => void
  ) {
    const isNewLanguage = !this.loadedLanguages.has(language)
    const shouldRefresh = this.shouldRefreshTranslations(this.timestamp)

    if (isNewLanguage || shouldRefresh) {
      this.loadedLanguages.add(language)
      this.client
        .getLanguageTranslations(language)
        .then((response: CrowdinGetLanguageTranslationResponse) =>{
          return response.find((i) => i.file === `/content/${language}.json`)
        })
        .then((r) => callback(null, r.content))
        .catch((error) => callback(error, null))
    } else {
      callback(null, null)
    }
  }
}

export default Backend
